import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Message, TreeNode } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute } from '@angular/router';

interface expandedRows {
    [key: string]: boolean;
}

@Component({
  selector: 'app-usuario-franquia-detalhar',
  templateUrl: './usuario-franquia-detalhar.component.html',
  styleUrls: ['./usuario-franquia-detalhar.component.scss']
})
export class UsuarioFranquiaDetalharComponent extends AdmihairBaseComponent implements OnInit {

  loadingGeral: boolean = false;
  loadingTable: boolean = false;
  usuarioId?: number;
  administradoraId?: number;
  usuario?: Usuario;


  colunasTreeTableSalvas: any[] = [];
  categoriasTreeTableSalvas: TreeNode[] = [];
  categoriasTreeTableSalvasSelecionada: TreeNode[] = [];

  listaPermissoes: CategoriaPermissaoAgrupada[] = [];
  expandedRows: expandedRows = {};
  isExpanded: boolean = false;

  constructor(private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioService: UsuarioService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService
  ) { super(erroService, utilStorageService) }

  ngOnInit(): void {
    this.loadingGeral = true;
    this.carregarId();
    this.administradoraId = this.getAdministradora().id;
    this.inicializarColunas();
    this.buscarUsuario();
  }

  carregarId() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.usuarioId = parseInt(idParam);
    }
  }

  inicializarColunas() {
    this.colunasTreeTableSalvas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }

  buscarUsuario() {
    this.usuarioService.buscarPorId(this.usuarioId).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.listarPermissoes();
      },
      error: (err: any) => {
        this.loadingGeral = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  listarPermissoes() {
    this.categoriaPermissaoService.listarAdicionadasPorUsuarioETipoFranquia(
      this.administradoraId, this.usuarioId
    ).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.listaPermissoes = data;
        this.categoriasTreeTableSalvas = this.converterParaTreeNode(data);
        this.loadingGeral = false;
      },
      error: (err: any) => {
        this.loadingGeral = false;
        this.exibirMensagemErro(err);
      }
    });
  }
 

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

}
